(function ($) {
    function setup_collapsible_submenus() {
        console.log('setup_collapsible_submenus: ');
        $("<div class='sub-menu-toggle'></div>").insertBefore("#menu-principal-mobile-cdr .et_mobile_menu .menu-item-has-children > a");
        $("#menu-principal-mobile-cdr .et_mobile_menu .sub-menu-toggle").click(function () {
            $(this).toggleClass("popped");
        });

    }
    $(document).ready(function () {
        setup_collapsible_submenus();
    });
})(jQuery);